// var aes_encrypt = require("./aes.js");

// import {aes_encrypt }  from "./aes.js"
var AES = require("./aes.js");

var ble_config = {
  UUID_SERVICE: "49535343-FE7D-4AE5-8FA9-9FAFD205E455",
  UUID_WRITE: "49535343-8841-43F4-A8D4-ECBE34729BB3",
  UUID_NOTIFY: "49535343-1E4D-4BD9-BA61-23C647249616",
  VERIFY_KEY: '7e3mmjjbVANsiMz5',

  CMD_VERSION: '7'.charCodeAt(0),
  CMD_SEND_RAND: 'O'.charCodeAt(0),
  CMD_VERIFY: 'P'.charCodeAt(0),
  CMD_OPEN_DOOR: 'Q'.charCodeAt(0),
  CMD_WRITE_KEY: 'M'.charCodeAt(0),

  CMD_CONTINUE: 0x90,
  CMD_FINISH: 0x91,
};

var ble_helper = {
  keyRand: new ArrayBuffer(16),
  keyDevice: new ArrayBuffer(16),
  isKeySetted: false,
  init: function () {
    ble_helper.isKeySetted = false;
    let k1 = new Uint8Array(ble_helper.keyRand);
    let k2 = new Uint8Array(ble_helper.keyDevice);
    for (var i = 0; i < 16; i++) {
      k1[i] = Math.floor(Math.random() * (255 + 1));
      k2[i] = 0;
    }
  },
  setKey: function (key, offset) {
    let len = key.length || key.byteLength || 0;
    if ((len - offset) >= 16) {
      ble_helper.isKeySetted = true;
      var k1 = key.length ? key : new Uint8Array(key);
      let k2 = new Uint8Array(ble_helper.keyDevice);
      for (var i = 0; i < 16; i++) {
        k2[i] = k1.charCodeAt(i + offset);
      }
    }
  },
  getVersionCommand: function () {
    let data = new ArrayBuffer(20);
    let bytes = new Uint8Array(data);
    for (var i = 0; i < data.byteLength; i++) {
      bytes[i] = 0xFF;
    }
    bytes[0] = 0x02;
    bytes[1] = 0x14;
    bytes[2] = ble_config.CMD_VERSION;
    bytes[19] = 0x03;
    return data;
  },
  sendRandCommand: function () {
    let data = new ArrayBuffer(20);
    let bytes = new Uint8Array(data);
    bytes[0] = 0x02;
    bytes[1] = 0x14;
    bytes[2] = ble_config.CMD_SEND_RAND;
    let k1 = new Uint8Array(ble_helper.keyRand);
    for (var i = 3; i < data.byteLength - 1; i++) {
      bytes[i] = k1[i];
    }
    bytes[19] = 0x03;
    return data;
  },
  writeKeyCommand: function (key) {
    let data = new ArrayBuffer(20);
    let bytes = new Uint8Array(data);
    bytes[0] = 0x02;
    bytes[1] = 0x14;
    bytes[2] = ble_config.CMD_WRITE_KEY;
    if (typeof (key) == "object") {
      if (key.length == 16) {
        for (var i = 3; i < data.byteLength - 1; i++) {
          bytes[i] = key[i];
        }
      } else if (key.byteLength == 16) {
        let k1 = new Uint8Array(key);
        for (var i = 3; i < data.byteLength - 1; i++) {
          bytes[i] = k1[i];
        }
      } else {
        throw "Key必须是16字节";
      }
    } else if (typeof (key) == "string" && key.length == 16) {
      for (var i = 3; i < data.byteLength - 1; i++) {
        bytes[i] = key.charCodeAt(i - 3);
      }
    } else {
      throw "Key格式不对";
    }
    bytes[19] = 0x03;

    ble_helper.setKey(key, 0);
    return data;
  },
  verifyCommand: function (deviceRand, key) {
    let data = new ArrayBuffer(20);
    let bytes = new Uint8Array(data);
    bytes[0] = 0x02;
    bytes[1] = 0x14;
    bytes[2] = ble_config.CMD_VERIFY;
    if (typeof (key) == "string" && deviceRand.byteLength == 16 && key.length == 16) {
      let k1 = new Uint8Array(deviceRand);
      let k2 = new Uint8Array(16);
      for (var i = 0; i < 16; i++) {
        k2[i] = key.charCodeAt(i);
      }
      let r = AES.encrypt(k1, k2);
      for (var i = 3; i < bytes.byteLength - 1; i++) {
        bytes[i] = parseInt(r.substr((i - 3) * 2, 2), 16);
      }
    }
    else if (deviceRand.byteLength == 16 && key.byteLength == 16) {
      let k1 = new Uint8Array(deviceRand);
      let k2 = new Uint8Array(key);
      let r = AES.encrypt(k1, k2);
      for (var i = 3; i < bytes.byteLength - 1; i++) {
        bytes[i] = parseInt(r.substr((i - 3) * 2, 2), 16);
      }
    } else {
      throw "Key必须是16字节";
    }
    bytes[19] = 0x03;
    return data;
  },
  openDoorCommand: function (isValid, cardId, feature) {
    if (typeof (cardId) != "string" || typeof (feature) != "string") {
      throw "参数格式不正确";
    }
    if (cardId.length != 8 && feature.length != 4) {
      throw "参数格式不正确";
    }
    if (!ble_helper.isKeySetted) {
      throw "未设置密钥";
    }
    let k1 = new Uint8Array(16);
    k1[0] = isValid ? 1 : 0;
    for (var i = 1; i <= 4; i++) {
      k1[i] = parseInt(cardId.substr((i - 1) * 2, 2), 16);
    }
    for (var i = 5; i < 7; i++) {
      k1[i] = parseInt(feature.substr((i - 5) * 2, 2), 16);
    }
    for (var i = 7; i < k1.byteLength; i++) {
      k1[i] = 0xFF;
    }
    let k2 = new Uint8Array(ble_helper.keyDevice);
    let r = AES.encrypt(k1, k2);

    let data = new ArrayBuffer(20);
    let bytes = new Uint8Array(data);
    bytes[0] = 0x02;
    bytes[1] = 0x14;
    bytes[2] = ble_config.CMD_OPEN_DOOR;
    for (var i = 3; i < bytes.byteLength - 1; i++) {
      bytes[i] = parseInt(r.substr((i - 3) * 2, 2), 16);
    }
    bytes[19] = 0x03;
    return data;
  }
};

function decode_x(str) {
  var key = [7, 28, 33, 30, 1];
  if (str.length > 0 && str.length % 2 == 0) {
    var a = new Uint8Array(str.length / 2);
    var res = "";
    for (var i = 0; i < a.length; i++) {
      a[i] = parseInt(str.substring(i * 2, i * 2 + 2), 16);
      a[i] ^= key[0] | key[4] | key[1] | key[3] | key[2];
      res += String.fromCharCode(a[i]);
    }
    return res;
  }
  return "";
}

var doorCmd = {
  received: false,
  index: 0
};
var sendRandResult = {
  deviceRand: null,
  serial: '',
  bindState: 0,
  readerType: 0
};
var verifyResult = {
  verified: false
};
var openDoorInfo = {
	device: null,
	key: ble_config.VERIFY_KEY,
	isValid: false,
	cardId: '',
	callback: null,
	addlog : function(str){}
};
var openDoorResult = {
  voltage: 0,
  recordCount: 0,
  addIndex: 0,
  delIndex: 0
};

function startOpenDoor(options) {
  openDoorInfo.device = options.device;
  openDoorInfo.key = options.key ? decode_x(options.key) : ble_config.VERIFY_KEY;
  openDoorInfo.isValid = options.isValid;
  openDoorInfo.cardId = options.cardId;
  openDoorInfo.callback = options.onComplete;
  openDoorInfo.addlog = options.addlog;

  doorCmd.index = 0;
  sendNextCommand();
}

function stopOpenDoor(openDoorResult) {
  if (openDoorInfo.callback) {
    openDoorInfo.callback(openDoorResult);
  }
}

function sendOpenDoorCommand() {
  var cardId;
  if (typeof (openDoorInfo.cardId) == "string") {
    cardId = openDoorInfo.cardId;
  } else {
    cardId = openDoorInfo.cardId.toString();
  }
  var card = cardId;
  var prefix = "0000";
  if (sendRandResult.readerType == 2) {
    if (card.length > 9) {
      card = card.substring(card.length - 9);
      prefix = cardId.substring(0, cardId.length - 9);
    }
  } else {
    if (card.length > 7) {
      card = card.substring(card.length - 7);
      prefix = cardId.substring(0, cardId.length - 7);
    }
  }
  card = parseInt(card, 10).toString(16);
  prefix = parseInt(prefix, 10).toString(16);
  if (card.length < 8) {
    var len = 8 - card.length;
    for (var i = 0; i < len; i++) {
      card = "0" + card;
    }
  }
  if (prefix.length < 4) {
    var len = 4 - prefix.length;
    for (var i = 0; i < len; i++) {
      prefix = "0" + prefix;
    }
  }
  var newCard = "";
  var feature = "";
  for (var i = 8; i > 0; i -= 2) {
    newCard += card.substring(i - 2, i);
  }
  for (var i = 4; i > 0; i -= 2) {
    feature += prefix.substring(i - 2, i);
  }
  openDoorInfo.addlog("开门数据:" + newCard + "," + feature);
  writeBluetooth(ble_helper.openDoorCommand(openDoorInfo.isValid, newCard, feature));
}

function writeBluetooth(buffer) {
	openDoorInfo.device.writeValue(buffer).catch(error=>{
		openDoorInfo.addlog(error);
		var str = error.toString();
		if(str.indexOf("GATT operation failed") != -1){
			stopOpenDoor(null);
		}else if(str.indexOf("GATT operation already") != -1){
			stopOpenDoor(null);
		}
	});
}

function sendNextCommand() {
  if (doorCmd.index == 0) {
    openDoorInfo.addlog("发送随机数");
    try {
      ble_helper.writeKeyCommand(openDoorInfo.key);
      writeBluetooth(ble_helper.sendRandCommand());
    } catch (e) {
      openDoorInfo.addlog(e);
    }
  } else if (doorCmd.index == 1) {
    openDoorInfo.addlog("发送设备随机数")
    try {
      writeBluetooth(ble_helper.verifyCommand(sendRandResult.deviceRand, openDoorInfo.key));
    } catch (e) {
      openDoorInfo.addlog(e);
      onReceiveData(false);
    }
  } else if (doorCmd.index == 2) {
    if (verifyResult.verified) {
      openDoorInfo.addlog("开门");
      try {
        sendOpenDoorCommand();
      } catch (e) {
        openDoorInfo.addlog("err:", e);
        onReceiveData(false);
      }
    } else {
      stopOpenDoor(null);
    }
  }
}

function onReceiveData(received) {
  doorCmd.received = received;
  if (doorCmd.received) {
    doorCmd.index++;
    if (doorCmd.index < 3) {
      sendNextCommand();
    } else {
      stopOpenDoor(openDoorResult);
    }
  } else {
    stopOpenDoor(null);
  }
}

function readBluetooth(buffer) {
  // console.log(`09`,encrypt)
  doorCmd.buffer = buffer;
  console.log(buffer);
  let result = new ArrayBuffer(16);
  let data = new Uint8Array(buffer);
  var temp = new Uint8Array(result);

  for (var i = 0; i < temp.byteLength; i++) {
    temp[i] = data[i + 3];
  }
  if (data[0] == 0x02 && data.byteLength >= data[1] && data[data[1] - 1] == 0x03) {
    switch (data[2]) {
      case ble_config.CMD_SEND_RAND:
        sendRandResult.deviceRand = result;
        sendRandResult.serial = "";
        for (var i = 0; i < 4; i++) {
          sendRandResult.serial += temp[i + 3] < 10 ? ("0" + temp[i + 3].toString(16)).toUpperCase() : temp[i + 3].toString(16).toUpperCase();
        }
        sendRandResult.bindState = temp[13] >> 4;
        sendRandResult.readerType = temp[13] & 0x0F;
        openDoorInfo.addlog("设备类型：" + (sendRandResult.readerType == 0 ? "门禁" : (sendRandResult.readerType == 1 ? "WG26读头" : "WG34读头")));
        break;
      case ble_config.CMD_VERIFY:
        verifyResult.verified = temp[0] != 0;
        openDoorInfo.addlog("验证" + (verifyResult.verified ? "成功" : "失败"));
        break;
      case ble_config.CMD_OPEN_DOOR:
        openDoorResult.voltage = (temp[0] << 8) + temp[1];
        openDoorResult.recordCount = (temp[2] << 8) + temp[3];
        openDoorResult.addIndex = (temp[4] << 24) + (temp[5] << 16) + (temp[6] << 8) + temp[7];
        openDoorResult.delIndex = (temp[8] << 24) + (temp[9] << 16) + (temp[10] << 8) + temp[11];
        break;
      default:
        break;
    }
  }
  onReceiveData(true);
}
export {
  ble_config,
  ble_helper,
  startOpenDoor,
  readBluetooth,
  openDoorInfo
}